import { HttpError } from "@kernel/frontend-react-app";
import { Variant, Variants } from "@kernel/react-ui-kit";
import { ErrorToast } from "./ErrorToast";

export class HttpErrorToast extends ErrorToast {
  constructor(protected error: HttpError, errorMessage: string) {
    super(errorMessage);
  }

  public header(): string {
    return `Errore Http ${this.error.code}`;
  }

  public bg(): Variant {
    return Variants.DANGER;
  }
}
